<!--
 * @Author: your name
 * @Date: 2020-09-25 10:50:24
 * @LastEditTime: 2020-10-13 18:44:26
 * @LastEditors: jml
 * @Description: In User Settings Edit
 * @FilePath: \saas-polymerization-c\src\views\game\puzzle\index.vue
-->
<template>
  <div class="puzzle" v-show="showThis">
    <div
      class="first-advertisement-url"
      v-show="info.isOpenFirstAdvertisement == 1 && firstAdvertisementTime >= 0 && info.firstAdvertisementUrl && !gameIsEnd && !gameIsNotRelease"
    >
      <img :src="info.firstAdvertisementUrl" alt />
      <div
        class="skip"
        @click="firstAdvertisementTime=-1"
      >{{firstAdvertisementTime > 0?`${firstAdvertisementTime}s,`:''}}跳过</div>
    </div>
    <div class="stance-1">
      <lLogo :logo="info.isOpenLogo==1?info.companyLogoUrl:''" class="logo-box"></lLogo>
      <img src="../img/puzzle/bg.png" alt class="bg absolute" />
      <img src="../img/puzzle/rule-5.png" class="rule absolute" @click="toRulePage" alt />
      <img src="../img/puzzle/i.png" class="i absolute" />
      <div class="main-content">
        <img src="../img/puzzle/slogan.png" alt class="slogan" />
        <img src="../img/puzzle/btn.png" class="btn" alt @click="toIndexPage" />
      </div>
    </div>
    <template v-if="!isPreview">
      <lEnd v-if="gameIsEnd"></lEnd>
      <lUnreleased v-if="gameIsNotRelease"></lUnreleased>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { puzzle } from '@/api/game';
import { customerUser } from '@/api/ajax';
import lLogo from './components/logo';
import lLogin from '../components/login';
import lEnd from '../components/end';
import lUnreleased from '../components/unreleased';
import { game } from '../mixins/game';
export default {
  name: 'puzzleGame',
  mixins: [game],
  data() {
    return {
      showThis: false,
      nowTime: new Date().getTime(),
      firstAdvertisementTime: 0
    };
  },
  components: { lLogo, lEnd, lUnreleased },
  computed: {
    gameIsEnd() {
      return this.info.endDt && this.info.endDt < this.nowTime;
    },
    gameIsNotRelease() {
      return 'isRelease' in this.info && this.info.isRelease != 1;
    }
  },
  methods: {
    toIndexPage() {
      if (this.isEdit && !this.isPreview) {
        return;
      }
      const { isRelease } = this.info;
      if (isRelease != 1 && !this.isPreview) {
        // 未发布
        this.$toast.fail('活动未发布');
        return;
      }
      // 验证是否登录
      this.verifyLogin()
        .then(res => {
          // 登录了，进入游戏页面
          this.$router.push({
            name: 'puzzleGameMain',
            query: this.$route.query
          });
        })
        .catch(err => {
          // 未登录，弹出登录窗
          this.$xrkDialog({
            content: lLogin,
            hideConfirm: true,
            confirmText: '完成',
            title: '为了便于活动奖品的顺利发放，请先完成手机号登录/注册验证',
            callback: params => {
              // 登录成功，进入游戏页面
              this.$router.push({
                name: 'puzzleGameMain',
                query: this.$route.query
              });
            }
          });
        });
    },
    toRulePage() {
      if (this.isEdit && !this.isPreview) {
        return;
      }
      this.$router.push({
        name: 'puzzleGameRule',
        query: this.$route.query
      });
    },
    getActiveInfo(channelNo, activityId) {
      puzzle.activityData({ channelNo, activityId }).then(res => {
        const { tJhEnterpriseActivityRule, prizeList } = res.data.data;
        this.firstAdvertisementTime =
          tJhEnterpriseActivityRule.firstAdvertisementTime;
        if (this.firstAdvertisementTime > 0) {
          const timeCount = time => {
            setTimeout(() => {
              this.firstAdvertisementTime >= 0 &&
                (this.firstAdvertisementTime = --time);
              if (time >= 0) {
                timeCount(time);
              }
            }, 1000);
          };
          timeCount(this.firstAdvertisementTime);
        }
        this.localSetInfo(tJhEnterpriseActivityRule, true);
        this.localSetRewards(prizeList);
        this.showThis = true;
        this.setShareUrl();
      });
    },
    async verifyLogin() {
      const {
        data: { data }
      } = await customerUser.obtainLoginUser();
      return new Promise((resolve, reject) => {
        if (data) {
          resolve(data);
        } else {
          reject('未登录');
        }
      });
    }
  },
  mounted() {
    const { id, channelNo } = this.$route.params;
    if (this.isEdit) {
      this.localSetInfo({
        isOpenLogo: 1,
        isRelease: 1,
        isDelete: 0,
        pics: []
      });
      this.localSetRewards([]);
      this.showThis = true;
    } else {
      this.getActiveInfo(channelNo, id);
    }
  },
  watch: {
    'info.firstAdvertisementTime': {
      handler(newV) {
        const n = parseInt(newV);
        if (this.isEdit) {
          this.firstAdvertisementTime = n;
          this.localSetInfo({
            isOpenFirstAdvertisement: n >= 0
          });
        }
      },
      deep: true
    },
    'info.firstAdvertisementUrl': {
      handler(newV) {
        if (this.isEdit) {
          this.localSetInfo({
            isOpenFirstAdvertisement: !!newV
          });
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="less" scoped>
.puzzle {
  width: 10rem;
  overflow: hidden;
  & > .first-advertisement-url {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99;
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .skip {
      position: fixed;
      right: 0.3rem;
      top: 0.4rem;
      color: #fff;
      padding: 0.1rem 0.3rem;
      line-height: 1;
      border-radius: 0.4rem;
      background-color: rgba(0, 0, 0, 0.6);
    }
  }
  .absolute {
    position: absolute;
  }
  .stance-1 {
    width: 100%;
    min-height: 100vh;
    position: relative;
    & > .logo-box {
      position: absolute;
      left: -0.1rem;
      top: 0;
      z-index: 2;
    }
    & > .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    & > .main-content {
      overflow-y: auto;
      position: absolute;
      width: 100%;
      height: 100%;
      padding-top: 1.3rem;
      text-align: center;
      & > .slogan {
        width: 9.987rem;
        height: 10.8rem;
      }
      & > .btn {
        width: 6.813rem;
        height: 2.333rem;
        margin-top: 2rem;
      }
    }
    & > .rule {
      width: 1.787rem;
      top: 1.28rem;
      right: 0.52rem;
      z-index: 2;
    }
    & > .i {
      right: 0;
      width: 2.227rem;
      height: 2.067rem;
      bottom: -0.5rem;
    }
  }
}
</style>
